// @flow
import { Grid } from 'semantic-ui-react';
import React from 'react';
import {
  getConfiguredMetricRowsFromFormikValuesForEstimateCC,
  getIfGivenRowIsBeingEditedORANewOneForEstimateCC,
  getMetricConfigBasedOnMetricNameForEstimateCC,
} from '@components/committed-capacity/utils';
import { EstimateCommittedCapacityRibbonContainer } from '@components/committed-capacity/EstimateCommittedCapacityRibbonContainer';
import { ECKUDimensionColumnsForEstimateCC } from '@components/committed-capacity/dimensions/ECKUDimensionColumnsForEstimateCC';
import { If } from '@presentational/If';
import { CommittedCapacityDimensionsLineItemDeleteContainerForEstimateCC } from '@components/committed-capacity/dimensions/CommittedCapacityDimensionsLineItemDeleteContainerForEstimateCC';
import { Spacer } from '@presentational/spacing/Spacer';
import { CommittedCapacityDimensionsLineItemSaveContainerForEstimateCC } from '@components/committed-capacity/dimensions/CommittedCapacityDimensionsLineItemSaveContainerForEstimateCC';
import { QuantityContainerForEstimateCC } from '@components/committed-capacity/dimensions/QuantityContainerForEstimateCC';
import { ESTIMATE_CC_METRIC_NAMES } from '@components/committed-capacity/enums';
import { useFormikContext } from 'formik';
import { CFUDimensionColumnsForEstimateCC } from '@components/committed-capacity/dimensions/CFUDimensionColumnsForEstimateCC';
import { ConnectDimensionColumnsForEstimateCC } from '@components/committed-capacity/dimensions/ConnectDimensionColumnsForEstimateCC';
import { TableflowDimensionColumnsForEstimateCC } from '@components/committed-capacity/dimensions/TableflowDimensionColumnsForEstimateCC';
import { DiscountContainerForEstimateCC } from '@components/committed-capacity/dimensions/DiscountContainerForEstimateCC';
import { DiscountOutOfBoundsWarningForEstimateCC } from '@components/committed-capacity/dimensions/DiscountOutOfBoundsWarningForEstimateCC';
import { DiscountedDSPSPPriceContainerForEstimateCC } from '@components/committed-capacity/dimensions/DiscountedDSPSPPriceContainerForEstimateCC';
import { DSPSPFixedDiscountInfoMessageForEstimateCC } from '@components/committed-capacity/dimensions/DSPSPFixedDiscountInfoMessageForEstimateCC';

const getStylesBasedOnTheGivenRowValues = (row) => {
  const style = getIfGivenRowIsBeingEditedORANewOneForEstimateCC(row)
    ? {
        backgroundColor: '#2185D014',
        borderRadius: '12px',
      }
    : {};

  return {
    ...style,
    paddingTop: '1rem',
    paddingBottom: '1rem',
  };
};

export const CommittedCapacityDimensionsSingleRowForEstimateCC = ({
  metricIndex,
  dimensionIndex,
  row,
  metricRow,
  dimensionArrayHelpers,
  metricArrayHelpers,
}) => {
  const { values } = useFormikContext();
  const configuredMetrics = getConfiguredMetricRowsFromFormikValuesForEstimateCC(values);
  const styles = getStylesBasedOnTheGivenRowValues(row);

  const metricName = metricRow.metricName;
  const metricConfig = getMetricConfigBasedOnMetricNameForEstimateCC(metricName);
  return (
    <>
      <Grid.Row style={styles}>
        <EstimateCommittedCapacityRibbonContainer row={row} />
        <If test={metricName === ESTIMATE_CC_METRIC_NAMES.ECKU}>
          <ECKUDimensionColumnsForEstimateCC
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <If test={metricName === ESTIMATE_CC_METRIC_NAMES.CFU}>
          <CFUDimensionColumnsForEstimateCC
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <If test={metricName === ESTIMATE_CC_METRIC_NAMES.CONNECT}>
          <ConnectDimensionColumnsForEstimateCC
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <If test={metricName === ESTIMATE_CC_METRIC_NAMES.TABLEFLOW}>
          <TableflowDimensionColumnsForEstimateCC
            dimensionIndex={dimensionIndex}
            metricIndex={metricIndex}
            row={row}
          />
        </If>
        <If test={metricName !== ESTIMATE_CC_METRIC_NAMES.DSP_STARTER_PACK}>
          <Grid.Column width={2}>
            <QuantityContainerForEstimateCC
              configuredMetrics={configuredMetrics}
              dimensionIndex={dimensionIndex}
              dimensionRow={row}
              metricIndex={metricIndex}
              metricRow={metricRow}
            />
          </Grid.Column>
        </If>
        <If test={metricName === ESTIMATE_CC_METRIC_NAMES.DSP_STARTER_PACK}>
          <Grid.Column width={2}>
            <DiscountedDSPSPPriceContainerForEstimateCC
              configuredMetrics={configuredMetrics}
              dimensionIndex={dimensionIndex}
              dimensionRow={row}
              metricIndex={metricIndex}
              metricRow={metricRow}
            />
          </Grid.Column>
        </If>
        <If test={metricConfig.shouldShowDiscountField}>
          <Grid.Column width={2}>
            <DiscountContainerForEstimateCC
              configuredMetrics={configuredMetrics}
              dimensionIndex={dimensionIndex}
              dimensionRow={row}
              metricIndex={metricIndex}
              metricRow={metricRow}
            />
          </Grid.Column>
        </If>
        <Grid.Column width={3}>
          <CommittedCapacityDimensionsLineItemSaveContainerForEstimateCC
            configuredMetrics={configuredMetrics}
            dimensionArrayHelpers={dimensionArrayHelpers}
            dimensionIndex={dimensionIndex}
            dimensionRow={row}
            metricRow={metricRow}
          />
          <Spacer x={15} />
          <CommittedCapacityDimensionsLineItemDeleteContainerForEstimateCC
            configuredMetrics={configuredMetrics}
            dimensionArrayHelpers={dimensionArrayHelpers}
            dimensionIndex={dimensionIndex}
            dimensionRow={row}
            metricArrayHelpers={metricArrayHelpers}
            metricIndex={metricIndex}
            metricRow={metricRow}
          />
          <If test={metricConfig.shouldShowDiscountField}>
            <Spacer x={15} />
            <DiscountOutOfBoundsWarningForEstimateCC dimensionRow={row} metricName={metricName} />
          </If>
        </Grid.Column>
      </Grid.Row>
      <DSPSPFixedDiscountInfoMessageForEstimateCC dimensionRow={row} metricName={metricName} />
    </>
  );
};
